module.exports = __webpack_public_path__ + "static/media/404.6f0147b8.png";